import { createAction } from 'redux-starter-kit';

export const SET_PRODUCTS = 'briefings/SET_PRODUCTS';
export const CLEAR_PRODUCTS = 'briefings/CLEAR_PRODUCTS';
export const SET_PRODUCT = 'briefings/SET_PRODUCT';
export const CLEAR_PRODUCT = 'briefings/CLEAR_BRIEFING';

export default {
  setProducts: createAction(SET_PRODUCTS),
  clearProducts: createAction(CLEAR_PRODUCTS),
  setProduct: createAction(SET_PRODUCT),
  clearBriefing: createAction(CLEAR_PRODUCT),
};
